const translations = {
    enter: 'ENTER',
    pleaseCorrectTheFollowing: 'PLEASE CORRECT THE FOLLOWING:'
};

export default translations;
